export enum EditViewType {
  NOTEBOOK = "notebook",
  GRAPH = "graph",
  APP = "app",
  DATA_APP = "data-app",
}

export const DEFAULT_VIEW: EditViewType = EditViewType.NOTEBOOK;
export const VIEW_SEPARATOR = ",";
